import PageList from "./PageList";
import PageEdit from "./PageEdit";

module.exports = [
    {path: '/page/list', component: PageList, meta: {title: 'Pages', group: 'page'}},
    {path: '/page/new', component: PageEdit, meta: {title: 'New Page', group: 'page'}},
    {path: '/page/edit/:id?', component: PageEdit, meta: {title: 'Edit Page', group: 'page'}},
]
